import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import useAuth from '@/common/hooks/useAuth.ts';
import LoadingPage from '@/common/pages/LoadingPage.tsx';
import { UserInfoQueryResponseType } from '@/common/queries/userInfo/userInfoQuery.type';
import { userInfoQueryOptions } from '@/common/queries/userInfo/userInfoQueryOptions.ts';
import { ProjectRoutes } from '@/config/routes/Routes.tsx';
import { ProjectUnAuthorisedRoutes } from '@/config/routes/UnAuthorisedRoutes.tsx';
import Clarity from '@microsoft/clarity';
import { useQuery } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const MainRoute = () => {
  const { hasToken, logOut } = useAuth();
  const { isLoading, isError } = useQuery({
    ...userInfoQueryOptions(hasToken),
    meta: {
      onSuccess: (data: UserInfoQueryResponseType) => {
        if (
          (window as any)?.env?.VITE_PROJECT_KEY ||
          import.meta.env.VITE_PROJECT_KEY
        ) {
          Clarity.setTag('mobile', data.phone_number);
          Clarity.setTag('firstName', data.first_name);
          Clarity.setTag('lastName', data.last_name);
        }
      },
    },
  });
  if (isError) {
    logOut();
  }
  if (isLoading) {
    return (
      <RouterProvider
        router={createBrowserRouter([
          {
            path: '*',
            element: (
              <MainLayout header="none" title="">
                <LoadingPage />
              </MainLayout>
            ),
          },
        ])}
      />
    );
  }
  return (
    <RouterProvider
      router={hasToken ? ProjectRoutes : ProjectUnAuthorisedRoutes}
    />
  );
};

export default MainRoute;
